import React from 'react';
import { withState } from '../../hocs/withState';
import Joi from 'joi-browser';
import { validationByJoi } from '../../utilities/commonValidation';
import regex from '../../utilities/validateRegex';
import { input } from '../../utilities/inputObjects';
import { messageUtility } from '../../utilities/messageUtility';
import styles from '../../styles/componentStyle/entrance/partner-company-register-form.scss';

/**
 *
 * CCUS連携入力ダイアログ
 * @param {Object} props
 */
const _CcusFieldDataLoadDialog = props => {
  const validate = value => {
    const scheme = Joi.object().keys({
      ccusid: Joi.string()
        .required()
        .regex(regex.pattern.hankaku, { name: 'hankaku' })
        .max(14),
    });
    let result = validationByJoi(scheme, { ccusid: value });
    props.updateStates({
      isError: !result.status,
      messages: result.messages.ccusid,
    });
    return result.status;
  };
  return (
    <div
      className='dialog-md dialog--modal'
      onClick={e => {
        e.stopPropagation();
      }}
    >
      <div className='dialog-md__header'>
        <span className='dialog-md__title'>CCUSからのデータの取得</span>
      </div>
      <div className='dialog-md__body'>
        <div className='dialog-content__body'>
          {messageUtility.getMessage('I-000-013')}
          <div className={styles['fields-ccus-dialog__inputs']}>
            <input
              ref={ref => {
                if (ref && !props.inputElem) {
                  props.updateStates({ inputElem: ref });
                }
              }}
              type='text'
              onBlur={() => {
                const value = props.inputElem.value;
                validate(value);
              }}
            />
            <div className='validate__message'>{props.messages}</div>
          </div>
        </div>
      </div>
      <div
        className={`${
          styles['ccus-dialog__btns']
        } dialog-md__footer-horizontal`}
      >
        <button
          className='btn--sub'
          onClick={() => {
            props.dialog.callback.back();
          }}
        >
          戻る
        </button>
        <button
          className={`btn-fixedsize ${props.isError &&
            'btn-fixedsize--disabled'}`}
          disabled={props.isError}
          onClick={() => {
            const value = props.inputElem.value;
            if (validate(value)) {
              props.dialog.callback.submit({ ccusid: value });
            }
          }}
        >
          取得
        </button>
      </div>
    </div>
  );
};

export const CcusFieldDataLoadDialog = withState(() => {
  return { isError: true, messages: '', inputElem: null };
})(_CcusFieldDataLoadDialog);



// WEBPACK FOOTER //
// ./src/components/modals/CcusFieldDataLoadDialog.jsx